import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { BaseCheckBox } from '../../controls/BaseCheckBox';
import { DealerInfo } from '../CustomerMade/DealerInfo';
import { OrderTextBox } from '../OrderTextBox';
import { EardrumHearingLossData } from './EardrumHearingLossData';

export class EardrumCustomerInfo extends Component {
    constructor(props) {
        super(props);
        this.state = { update: false };
        this.handleEarSurgery = this.handleEarSurgery.bind(this);
        this.handleEarInflammation = this.handleEarInflammation.bind(this);
        this.handleEardrumOrderType = this.handleEardrumOrderType.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        var model = this.props.model;
        if (model) {
            switch (name) {
                case "customerName":
                    model.customerName = value;
                    break;
                case "customerAge":
                    model.customerAge = value;
                    break;
                case "specialRequirements":
                    model.specialRequirements = value;
                    break;
                case "hearingAidModel":
                    model.hearingAidModel = value;
                    break;
                case "lastEardrumNumber":
                    model.lastEardrumNumber = value;
                    break;
            }

            this.updateUi();
        }
    }

    updateUi() {
        let update = !this.state.update;
        this.setState({ update: update });
    }

    handleEardrumOrderType(event) {
        const target = event.target;
        const checked = target.checked;
        const value = target.value;
        var model = this.props.model;
        if (model) {
            if (checked) {
                model.eardrumOrderType = parseInt(value);
            }
            else {
                model.eardrumOrderType = -1;
            }
            this.updateUi();
        }
    }

    handleEarSurgery(event) {
        const target = event.target;
        const checked = target.checked;
        const value = target.value;
        var model = this.props.model;
        if (model) {
            if (checked) {
                model.earSurgery = parseInt(value);
            }
            else {
                model.earSurgery = -1;
            }
            this.updateUi();
        }
    }

    handleEarInflammation(event) {
        const target = event.target;
        const checked = target.checked;
        const value = target.value;
        var model = this.props.model;
        if (model) {
            if (checked) {
                model.earInflammation = parseInt(value);
            }
            else {
                model.earInflammation = -1;
            }
            this.updateUi();
        }
    }

    render() {
        let model = this.props.model;
        if (!model) {
            return null;
        }
        let hisGap = "gap-2";
        let printing = this.props.printing;
        if (printing || this.props.printMode) {
            hisGap = "gap-x-2 gap-y-1";
        }

        return (
            <div className="flex justify-between gap-1">
                <div className="w-full">
                    <DealerInfo model={this.props.dealerInfo} />
                </div>
                <div className="w-full">
                    <div className="flex">
                        <div className="border-0 border-red-300 flex flex-col justify-between">
                            <div className="flex items-center border-2 border-gray-300 p-1">
                                <div className="">
                                    <label className="w-full truncate"><FormattedMessage id="CustomerName" /><span className="font-bold text-red-600">*</span></label>
                                </div>
                                <div className="">
                                    <OrderTextBox name="customerName" classnames="w-16" value={model.customerName ?? ""} onChange={this.handleInputChange} />
                                </div>
                                <div className="">
                                    <label className="w-full truncate"><FormattedMessage id="CustomerAge" /></label>
                                </div>
                                <div className="">
                                    <OrderTextBox classnames="w-8" name="customerAge" value={model.customerAge ?? ""} onChange={this.handleInputChange} />
                                </div>
                            </div>
                            <div className="border-l-2 border-t-2 border-r-2 border-b border-gray-300 p-1">
                                <div className="border-b border-gray-200">
                                    <label className="font-bold"><FormattedMessage id="UserHistory" /></label>
                                </div>
                                <div className="grid grid-cols-2 pt-1">
                                    <div className="flex flex-col items-center gap-1 border-r border-gray-200">
                                        <label className="w-12"><FormattedMessage id="EarSurgery" /></label>
                                        <div className="flex">
                                            <label className="inline-flex items-center">
                                                <BaseCheckBox type="checkbox" value={0} checked={model.earSurgery === 0} onChange={this.handleEarSurgery}></BaseCheckBox>
                                                <span class="ml-1"><FormattedMessage id="No" /></span>
                                            </label>
                                            <label className="inline-flex items-center">
                                                <BaseCheckBox classnames="ml-1" type="checkbox" value={1} checked={model.earSurgery === 1} onChange={this.handleEarSurgery}></BaseCheckBox>
                                                <span class="ml-1"><FormattedMessage id="Yes" /></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="flex flex-col items-center gap-1">
                                        <label className="w-12"><FormattedMessage id="EarInflammation" /></label>
                                        <div className="flex">
                                            <label className="inline-flex items-center">
                                                <BaseCheckBox type="checkbox" value={0} checked={model.earInflammation === 0} onChange={this.handleEarInflammation}></BaseCheckBox>
                                                <span class="ml-1"><FormattedMessage id="No" /></span>
                                            </label>
                                            <label className="inline-flex items-center">
                                                <BaseCheckBox classnames="ml-1" type="checkbox" value={1} checked={model.earInflammation === 1} onChange={this.handleEarInflammation}></BaseCheckBox>
                                                <span class="ml-1"><FormattedMessage id="Yes" /></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pl-1 pb-1 border-b-2 border-gray-300 w-full">
                            <div className="border-2 border-gray-300 w-full">
                                <EardrumHearingLossData data={model.hearingLossData} />
                            </div>
                        </div>
                    </div>
                    <div className="border-l-2 border-r-2 border-b-2 border-gray-300 p-1">
                        <div className="">
                            <label ><FormattedMessage id="SpecialRequirements" /></label>
                        </div>
                        <div className="">
                            <textarea className="text-xs leading-4 py-1 bg-gray-100 border-gray-200 focus:ring-indigo-500 focus:border-indigo-500 rounded-sm h-10 w-full" name="specialRequirements" value={model.specialRequirements ?? ""} onChange={this.handleInputChange}></textarea>
                        </div>
                    </div>
                </div>
                <div className="w-1/3">
                    <div className="w-full flex flex-col justify-between gap-1">
                        <div className="flex justify-between items-center border-2 border-gray-300 p-1">
                            <label className="font-bold whitespace-nowrap"><FormattedMessage id="HearingAidModel" /></label>
                            <OrderTextBox classnames="w-full" name="hearingAidModel" value={model.hearingAidModel ?? ""} onChange={this.handleInputChange} />
                        </div>
                        <div className={"border-2 border-gray-300 flex flex-col justify-end " + hisGap}>
                            <div className="border-b border-gray-200 font-bold pl-1" colSpan="2"><FormattedMessage id="EardrumOrderType" /></div>
                            <div className="flex justify-start">
                                <div className="border-gray-200 w-2/5">
                                    <div className="flex justify-center">
                                        <div className="place-self-center inline-flex items-center">
                                            <BaseCheckBox type="checkbox" name="eardrumOrderType0" value={0} checked={model.eardrumOrderType === 0} onChange={this.handleEardrumOrderType}></BaseCheckBox>
                                            <span className="ml-1"><FormattedMessage id="NewEarMold" /></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="border-gray-200 w-3/5">
                                    <div className="flex justify-center">
                                        <div className="place-self-center inline-flex items-center">
                                            <BaseCheckBox type="checkbox" name="eardrumOrderType3" value={3} checked={model.eardrumOrderType === 3} onChange={this.handleEardrumOrderType}></BaseCheckBox>
                                            <span className="ml-1"><FormattedMessage id="NewEarMoldAlreadySamples" /></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-start">
                                <div className="border-gray-200">
                                    <div className="flex justify-center">
                                        <div className="place-self-center inline-flex items-center">
                                            <BaseCheckBox type="checkbox" name="eardrumOrderType1" value={1} checked={model.eardrumOrderType === 1} onChange={this.handleEardrumOrderType}></BaseCheckBox>
                                            <span className="ml-1"><FormattedMessage id="Repair" /></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="border-gray-200">
                                    <div className="flex justify-center">
                                        <div className="place-self-center inline-flex items-center">
                                            <BaseCheckBox type="checkbox" name="eardrumOrderType2" value={2} checked={model.eardrumOrderType === 2} onChange={this.handleEardrumOrderType}></BaseCheckBox>
                                            <span className="ml-1"><FormattedMessage id="RedoEarMold" /></span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="flex justify-between items-center border-t border-gray-200 p-1">
                                <label className=""><FormattedMessage id="LastEardrumNumber" /></label>
                                <OrderTextBox classnames="w-full" name="lastEardrumNumber" value={model.lastEardrumNumber ?? ""} onChange={this.handleInputChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}